module.exports = __webpack_public_path__ + "public/images/slider/loseva-circle.cecc75a0c0d5f12191c18f2ee719f151.png";